/** Hebrew progress labels shown while the agent runs a tool. */
export const TOOL_LABELS: Record<string, string> = {
  search_contacts: 'מחפש אנשי קשר...',
  get_contact: 'שולף פרטי איש קשר...',
  get_all_circles_options: 'שולף רשימות מעגלים...',
  get_commitments_dashboard: 'שולף נתוני התחייבויות...',
  get_recent_activities: 'שולף פעילויות אחרונות...',
  get_activities_by_topic: 'מסכם פעילויות לפי נושא...',
  get_contact_tag_counts: 'סופר אנשי קשר לפי קבוצות...',
  get_important_dates: 'בודק תאריכים חשובים...',
  get_donations_summary: 'שולף נתוני תרומות...',
  update_contact: 'מכין עדכון פרטים...',
  create_contact: 'מכין איש קשר חדש...',
  add_custom_field: 'מכין אפשרות חדשה...'
};

export const getToolLabel = (name: string) => TOOL_LABELS[name] || 'שולף נתונים...';
